module.exports = __webpack_public_path__ + "img/23_117.c5a8f2ec.png";